import { render } from "./ManagementPlanStepAdder.vue?vue&type=template&id=0273f490&ts=true"
import script from "./ManagementPlanStepAdder.vue?vue&type=script&lang=ts"
export * from "./ManagementPlanStepAdder.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__